<script>
import axios from "axios";

import TitlePage from "../layout/TitlePage.vue";
import Card from "../ui/Card.vue";
import Modal from "../ui/Modal.vue";
import FormFiltro from "../formulario/FormFiltro.vue";
import FormFiltroGenerico from "../formulario/FormFiltroGenerico.vue";
import FormFiltroCliente from "../formulario/FormFiltroCliente.vue";

import { mapGetters, mapActions, mapState } from "vuex";
import FiltroDashboard from "../formulario/FiltroDashboard.vue";
import despachosService from "../../services/despachos.service.js";

export default {
  components: {
    TitlePage,
    Card,
    Modal,
    FormFiltro,
    FormFiltroGenerico,
    FormFiltroCliente,
    FiltroDashboard,
  },
  data() {
    return {
      showEditar: false,
      showEliminar: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      fields: [
        { key: "codigo", label: "N° Despacho" },
        { key: "cliente.nombre", label: "Cliente" },
        { key: "fecha", label: "ETA" },
        { key: "tipo_despacho", label: "Tipo de Despacho" },
        { key: "tipo.aduana.nombre", label: "Aduana" },
        { key: "tipo.nombre_transporte", label: "Medio de Transporte" },
        { key: "cod_agente", label: "Cod. Agente" },
        { key: "estado_despacho", label: "Estado" },
        { key: "created_at", label: "Fecha ingreso" },
        { key: "actions", label: "Acciones" },
      ],
      //items: [],
      isBusy: false,
      listaDespachos: [],

      //Listas para usar en los select filtros
      filtros: {
        listaAduanas: null,
        listaPedidores: null,
        listaAdministrativas: null,
        listaAgentes_carga: null,
        listaCaracteristicas_carga: null,
        listaEstados_despacho: null,
        listaEstados_retiro: null,
        listaGestores: null,
        listaJefes_operaciones: null,
        listaNombres_transporte: null,
        listaNombre_cliente: null,
        listaNombre_nave: null, //filtro por nombre de nave
        listaTipos_carga: null,
        listaTipos_condicion: null,
        listaTramitadores_aduaneros: null,
        listaAforos: null,
        listaRevisores: null,
        listaDespachos: null,
      },

      formFiltro: {
        page: this.currentPage,
        filters: {},
      },
      formFiltro2: [{ id: this.id, tipo: "codigo", value: "" }],
      formDispatch: {
        estado_despacho: null,
      },
      changeState: false,
      listaEstadosDespacho: null,
      itemEditando: null,
    };
  },
  computed: {
    ...mapState({
      dispatchSearch: "filtros/getDispatchSearch",
    }),
    ...mapGetters({
      filtro: "filtros/filtro",
      fecha: "filtros/fecha",
      items: "despachos/despachos",
      getDispatchSearch: "filtros/getDispatchSearch",
    }),
  },
  methods: {
    ...mapActions({
      cambiarFiltro: "filtros/cambiarFiltro",
      setDispatches: "despachos/setDispatches",
      setEstadoDespachos: "despachos/setDispatchState",
      setDispatchSearch: "filtros/setDispatchSearch",
    }),

    opcionesRetiro() {
      const permitidos = ['Retiro Parcial', 'Retiro Total'];
      return this.listaEstadosDespacho.filter(estado => permitidos.includes(estado));
    },

    //LLAMADAS API

    async deleteDispatch(id) {
      let variable = await this.$swal({
        title: "¿Deseas eliminar este despacho?",
        text: "¿Está seguro? ¡No podrás revertir esto!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Borrar!",
        cancelButtonText: "No, cancelar!",
        buttonsStyling: true,
      });

      if (variable.isConfirmed == true) {
        await axios
          .delete(`/api/admin/despachos/${id}`)
          .then((resp) => {
            this.fetchDispatches();
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.$swal({
                icon: "error",
                title: "¡Error!",
                text: err.response.data.message,
              });
            }
          });
      }
    },
    async confirmarEliminar() {
      await axios
        .delete(`/api/admin/clients/${this.idUsuarioEliminar}`)
        .then((resp) => {
          this.getClients();
        })
        .catch((err) => {
          console.log(err);
        });
      this.cerrarModal();
    },
    abrirModalEstado(item) {
        this.itemEditando = item;
        this.formDispatch.estado_despacho = item.estado_despacho;
        this.changeState = true;
    },
    //Cambiar estado de despacho manualmente
    async confirmarChangeState() {
      if (!this.itemEditando) return;
      
      const itemId = this.itemEditando.id;
      const nuevoEstado = this.formDispatch.estado_despacho;

      try {
        await despachosService.cambiarEstadoDespacho(itemId, nuevoEstado);
        
        this.fetchDispatches(); 
        
        this.cerrarModal();
        
      } catch (err) {
        console.error(err);
        this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo actualizar el estado'
        });
      }
      this.changeState = false;
    },

    async submit() {
      try {
        const { status } = await axios.put(
          `api/admin/clients/${this.formCliente.client_id}`,
          this.formCliente
        );

        this.cerrarModal();
        this.getClients();
      } catch (err) {
        console.error(err);
      }
    },

    ver(item, index, button) {
      const routeData = this.$router.resolve({
        name: "PerfilDespacho",
        params: { despachoId: item.id },
      });
      window.open(routeData.href, "_blank");
    },
    agregar(item, index, button) {
      this.$router.push({ name: "Crear" });
    },
    limpiar() {
      this.cambiarFiltro({
        estado: false,
        texto: "-",
        value: "-",
        filtro: "-",
      });

      this.setDispatchSearch(null);

      this.formFiltro.page = 1;
      this.formFiltro.filters = {};
      this.fetchDispatches();
    },

    eliminar(item, index, button) {
      this.nombreUsuarioEliminar = item.short_name;
      this.idUsuarioEliminar = item.id;
      this.showEliminar = true;
    },
    async fetchDispatches(form = null) {
      let query = null;

      try {
        const resp = await despachosService.getListaEstadosDespacho();
        this.listaEstadosDespacho = resp.data;
      } catch (err) {
        console.log(err);
      }

      if (this.getDispatchSearch && this.getDispatchSearch.trim() !== "") {
        query = {
          filters: {
            codigo: [this.getDispatchSearch],
          },
          page: this.currentPage,
        };

        this.formFiltro.filters = {};
      }

      if (form) {
        this.formFiltro.page = 1;
        this.formFiltro.filters = {};
        this.generarForm(form);
      }

      if (this.filtro && this.filtro.estado == true) {
        this.generarFormFiltrar();
      }
      this.toggleBusy();

      try {
        const { data } = await axios.post(
          "/api/admin/despachos/filtered",
          Object.keys(this.formFiltro.filters).length > 0
            ? this.formFiltro
            : query
            ? query
            : this.formFiltro
        );

        if (data?.data && data?.meta) {
          this.setDispatches(data.data);

          this.currentPage = data.meta.current_page;
          this.totalRows = data.meta.total;
          this.perPage = data.meta.per_page;
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: "Un error ha ocurrido",
        });
      } finally {
        this.toggleBusy();
      }
    },
    //Generar Forumario
    generarFormFiltrar() {
      if (this.fecha) this.formFiltro.filters["fecha"] = this.fecha;
      switch (this.filtro.filtro) {
        case "despachos_pendientes":
          this.formFiltro.filters["estado_contenedores"] = "PENDIENTE";
          break;
        case "despachos_parcial":
          this.formFiltro.filters["estado_contenedores"] = "PARCIAL";
          break;
        case "despachos_total":
          this.formFiltro.filters["estado_contenedores"] = "TOTAL";
          break;
        case "aforo":
          this.formFiltro.filters["aforo"] = [1];
          break;
        case "visto_bueno":
          this.formFiltro.filters["visto_bueno"] = [1];
          break;
        case "documentos_faltantes":
          this.formFiltro.filters["documentos_faltantes"] = true;
          break;
        case "documentos_completos":
          this.formFiltro.filters["documentos_completos"] = true;
          break;
        case "aforo_realizados":
          this.formFiltro.filters["aforo_realizados"] = true;
          break;
        case "aforo_pendientes":
          this.formFiltro.filters["aforo_pendientes"] = true;
          break;
        case "visto_buenos-pendientes":
          this.formFiltro.filters["visto_buenos-pendientes"] = true;
          break;
        case "visto_buenos-relizados":
          this.formFiltro.filters["visto_buenos-relizados"] = true;
          break;
        case "vencimiento-eta":
          this.formFiltro.filters["vencimiento-eta"] = true;
          break;
        case "eta-vencida":
          this.formFiltro.filters["eta-vencida"] = true;
          break;
      }
    },
    generarForm(form) {
      form.forEach((el) => {
        switch (el.type) {
          case "fecha":
            if (!this.formFiltro.filters.fecha_inicio)
              this.formFiltro.filters["fecha_inicio"] = [];
            this.formFiltro.filters.fecha_inicio.push([
              el.fecha[0],
              el.fecha[1],
            ]);
            break;
          case "pedidor":
            if (!this.formFiltro.filters.users)
              this.formFiltro.filters["users"] = [];
            this.formFiltro.filters.users.push(el.value);
            break;
          case "revisor":
            if (!this.formFiltro.filters.users)
              this.formFiltro.filters["users"] = [];
            this.formFiltro.filters.users.push(el.value);
            break;
          case "aduana":
            if (!this.formFiltro.filters.aduana)
              this.formFiltro.filters["aduana"] = [];
            this.formFiltro.filters.aduana.push(el.value);
            break;
          case "administrativas":
            if (!this.formFiltro.filters.users)
              this.formFiltro.filters["users"] = [];
            this.formFiltro.filters.users.push(el.value);
            break;
          case "tipos_carga":
            if (!this.formFiltro.filters.tipo_carga)
              this.formFiltro.filters["tipo_carga"] = [];
            this.formFiltro.filters.tipo_carga.push(el.value);
            break;
          case "tramitadores_aduaneros":
            if (!this.formFiltro.filters.tramitadores_aduaneros)
              this.formFiltro.filters["tramitadores_aduaneros"] = [];
            this.formFiltro.filters.tramitadores_aduaneros.push(el.value);
            break;
          case "estados_despacho":
            if (!this.formFiltro.filters.estados_despacho)
              this.formFiltro.filters["estados_despacho"] = [];
            this.formFiltro.filters.estados_despacho.push(el.value);
            break;
          case "estados_retiro":
            if (!this.formFiltro.filters.estados_retiro)
              this.formFiltro.filters["estados_retiro"] = [];
            this.formFiltro.filters.estados_retiro.push(el.value);
            break;
          case "gestores":
            if (!this.formFiltro.filters.users)
              this.formFiltro.filters["users"] = [];
            this.formFiltro.filters.users.push(el.value);
            break;
          case "agentes_carga":
            if (!this.formFiltro.filters.agentes_carga_id)
              this.formFiltro.filters["agentes_carga_id"] = [];
            this.formFiltro.filters.agentes_carga_id.push(el.value);
            break;
          case "caracteristicas_carga":
            if (!this.formFiltro.filters.caracteristicas_carga)
              this.formFiltro.filters["caracteristicas_carga"] = [];
            this.formFiltro.filters.caracteristicas_carga.push(el.value);
            break;
          case "jefes_operaciones":
            if (!this.formFiltro.filters.users)
              this.formFiltro.filters["users"] = [];
            this.formFiltro.filters.users.push(el.value);
            break;
          case "nombres_transporte":
            if (!this.formFiltro.filters.nombre_transporte)
              this.formFiltro.filters["nombre_transporte"] = [];
            this.formFiltro.filters.nombre_transporte.push(el.value);
            break;
          //TODO:filtro
          case "nombre_nave":
            if (!this.formFiltro.filters.nombre_nave)
              this.formFiltro.filters["nombre_nave"] = [];
            this.formFiltro.filters.nombre_nave.push(el.value);
            break;
          case "cliente_id":
            if (!this.formFiltro.filters.cliente_id)
              this.formFiltro.filters["cliente_id"] = [];
            this.formFiltro.filters.cliente_id.push(el.value);
            break;
          case "codigo":
            if (!this.formFiltro.filters.codigo)
              this.formFiltro.filters["codigo"] = [];
            this.formFiltro.filters.codigo.push(el.value);
            this.value = el.value;
            break;
          case "aforo":
            if (!this.formFiltro.filters.aforo)
              this.formFiltro.filters["aforo"] = [];
            this.formFiltro.filters.aforo.push(el.value);
            break;
          case "aforo_termino":
            if (!this.formFiltro.filters.aforo_termino)
              this.formFiltro.filters["aforo_termino"] = [];
            this.formFiltro.filters.aforo_termino.push(el.value);
            break;
          case "tipos_condicion":
            if (!this.formFiltro.filters.tipo_condicion)
              this.formFiltro.filters["tipo_condicion"] = [];
            this.formFiltro.filters.tipo_condicion.push(el.value);
            break;
          case "mainifiesto":
            if (!this.formFiltro.filters.tipo_condicion)
              this.formFiltro.filters["tipo_condicion"] = [];
            this.formFiltro.filters.tipo_condicion.push(el.value);
            break;
          case "transporte":
            if (!this.formFiltro.filters.transporte)
              this.formFiltro.filters["transporte"] = [];
            this.formFiltro.filters.transporte.push(el.value);
            break;
          case "ref_cliente":
            if (!this.formFiltro.filters.referencia_cliente)
              this.formFiltro.filters["referencia_cliente"] = [];
            this.formFiltro.filters.referencia_cliente.push(el.value);
            break;
          case "numero_manifiesto":
            if (!this.formFiltro.filters.numero_manifiesto)
              this.formFiltro.filters["numero_manifiesto"] = [];
            this.formFiltro.filters.numero_manifiesto.push(el.value);
            break;
          case "numero_documento_transporte":
            if (!this.formFiltro.filters.numero_documento_transporte)
              this.formFiltro.filters["numero_documento_transporte"] = [];
            this.formFiltro.filters.numero_documento_transporte.push(el.value);
            break;
          case "cliente.nombre":
            if (!this.formFiltro.filters["cliente.nombre"])
              this.formFiltro.filters["cliente.nombre"] = [];
            this.formFiltro.filters["cliente.nombre"].push(el.value);
            break;
        }
      });
    },
    //EXCEL
    async generarReporteImportaciones() {
      this.formFiltro.page = 1;
      await axios
        .post("/api/admin/reportes/despachos/filtros", this.formFiltro)
        .then((resp) => {
          window.open(
            process.env.VUE_APP_API_URL +
              `/api/admin/reportes/despachos/importaciones`
          );
          // console.log(resp)
        })
        .catch((err) => {
          // this.toggleBusy();
        });
    },

    async generarReporteExportaciones() {
      this.formFiltro.page = 1;
      await axios
        .post("/api/admin/reportes/despachos/filtros", this.formFiltro)
        .then((resp) => {
          window.open(
            process.env.VUE_APP_API_URL +
              `/api/admin/reportes/despachos/exportaciones`
          );
          // console.log(resp)
        })
        .catch((err) => {
          // this.toggleBusy();
        });
    },
    getEstadoClass(estado) {
      if (!estado) return "";

      const baseClass = "state-base-style";
      const mapaEstados = {
        'Recepcionado': 'state-recepcionado',

        'Pendiente CDA': 'state-pend-cda',
        'Pendiente B/L Corregido': 'state-pend-bl-corregido',
        'Pendiente Doc. de Transporte': 'state-pend-doc-transporte',
        'Pendiente Factura Comercial': 'state-pend-fact-comercial',
        'Pendiente Presentación': 'state-pend-presentacion',

        'UyD Pendiente': 'state-uyd-pendiente',

        'Presentado': 'state-presentado', // Legacy
        'Presentado sin pago': 'state-presentado-sin-pago',
        'Presentado Pendiente de pago': 'state-presentado-pend-pago',
        'Presentado y Pagado': 'state-presentado-pagado',

        'Retiro Parcial': 'state-retiro-parcial',
        'Retiro Total': 'state-retiro-total',
        'Retirado': 'state-retirado', // Legacy
        'Legalizado': 'state-legalizado' // Legacy
      };

      return baseClass + " " + (mapaEstados[estado] || 'state-pendiente');
    },

    permiteRetiroManual(estado) {
      const estadosPermitidos = [
        'Presentado sin pago',
        'Presentado y Pagado', 
        'UyD Pendiente', 
        'Retiro Parcial', 
        'Retiro Total'
      ];
      
      return estadosPermitidos.includes(estado);
    },

    //GENERICOS
    cerrarModal() {
      this.showEditar = false;
      this.showEliminar = false;
      this.changeState = false;
      this.itemEditando = null;
    },
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },
  },
  watch: {
    currentPage: function (newValue) {
      this.formFiltro.page = newValue;
      this.fetchDispatches();
    },
    getDispatchSearch: function () {
      this.fetchDispatches();
    },
  },
  mounted() {
    this.fetchDispatches();
  },
};
</script>

<template>
  <div class="flex flex-col gap-8">
    <TitlePage title="Despachos" />
    <card title="Filtros" permiso="dispatch.create" :boton="false">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-12 pb-12">
        <filtro-dashboard class="sm:col-span-2" />
        <form-filtro
          label_filtro="Agregar filtro"
          @fetch="
            (form) => {
              setDispatchSearch(null);
              fetchDispatches(form);
            }
          "
          @clear-filter="() => limpiar()"
        >
        </form-filtro>

        <div
          v-for="filtro in formFiltro2"
          :key="filtro.id"
          class="flex flex-col gap-4"
        >
          <form-filtro-generico
            :filtro="filtro"
            label_filtro="Filtro por N° de documento de transporte"
            tipoFiltro="numero_documento_transporte"
            @submit="
              (val) => {
                setDispatchSearch(null);
                fetchDispatches(val);
              }
            "
            @limpiar="() => limpiar()"
          />

          <form-filtro-cliente
            :lista-clientes="filtros.listaNombre_cliente"
            :label_filtro="'Filtro por cliente'"
            @submit="
              (val) => {
                setDispatchSearch(null);
                fetchDispatches(val);
              }
            "
            @limpiar="() => limpiar()"
          />
        </div>
      </div>
    </card>
    <card
      title="Despachos"
      :accionBoton="agregar"
      permiso="dispatch.create"
      :boton="true"
      text="Agregar"
      :segundoaccionBoton="generarReporteImportaciones"
      :segundoboton="true"
      segundotext="Reporte Importaciones"
      :terceraAccionBoton="generarReporteExportaciones"
      :tercerBoton="true"
      tercerText="Reporte Exportaciones"
    >
      <b-table
        class="table-index text-left"
        responsive
        hover
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
      >
        <template #empty>
          <h4 class="text-center">No hay despachos disponibles</h4>
        </template>

        <template #cell(codigo)="row">
          <div
            class="codigo-importacion"
            v-if="row.item.tipo_despacho == 'importacion'"
          >
            <div>
              <fas
                v-if="row.item.readonly"
                size="sm"
                :id="'popover-im-' + row.item.id"
                style="cursor: pointer"
                :icon="['fas', 'exclamation-circle']"
              ></fas>
              {{ row.item.codigo ?? "-" }}
              <b-popover
                v-if="row.item.readonly"
                :target="`popover-im-` + row.item.id"
                title="Advertencia - Permisos"
                triggers="hover focus"
                :content="'No se cuentan permisos para este despacho. Solo se pueden visualizar los datos!'"
              ></b-popover>
            </div>
          </div>
          <div class="codigo-exportacion" v-else>
            <p>
              <fas
                v-if="row.item.readonly"
                size="sm"
                :id="'popover-ex-' + row.item.id"
                style="cursor: pointer"
                :icon="['fas', 'exclamation-circle']"
              ></fas>
              {{ row.item.codigo ?? "-" }}
              <b-popover
                v-if="row.item.readonly"
                :target="`popover-ex-` + row.item.id"
                title="Advertencia - Permisos"
                triggers="hover focus"
                :content="'No se cuentan permisos para este despacho. Solo se pueden visualizar los datos!'"
              ></b-popover>
            </p>
          </div>
        </template>

        <template #cell(tipo_carga)="row">
          <p v-if="row.item.tipo_carga">
            {{ row.item.tipo_carga ?? "-" }}
          </p>
          <p v-else>-</p>
        </template>
        <template #cell(requiere_vistos_buenos)="row">
          <p v-if="row.item.requiere_vistos_buenos == 1">Si</p>
          <p v-else>No</p>
        </template>
        <template #cell(tipo_despacho)="row">
          <div
            class="estado-despacho importacion"
            v-if="row.item.tipo_despacho == 'importacion'"
          >
            <p class="">Importación</p>
          </div>
          <div class="estado-despacho exportacion" v-else>
            <p>Exportación</p>
          </div>
        </template>
        <template #cell(estado_despacho)="row">
          <div class="flex justify-center items-center w-full">
            <button
              v-if="permiteRetiroManual(row.item.estado_despacho)"
              :class="getEstadoClass(row.item.estado_despacho)"
              @click="abrirModalEstado(row.item)"
            >
              {{ row.item.estado_despacho }}
            </button>
            
            <span 
                v-else
                :class="getEstadoClass(row.item.estado_despacho)"
            >
              {{ row.item.estado_despacho }}
            </span>
          </div>
        </template>
        <template #cell(fecha)="row">
          <div
            class="text-nowrap"
            v-if="row.item.tipo_despacho == 'importacion'"
          >
            {{
              row.item.tipo.fecha_eta
                ? moment(row.item.tipo.fecha_eta).format("DD-MM-YYYY")
                : "-"
            }}
          </div>
          <p v-if="row.item.tipo_despacho == 'exportacion'">
            {{
              row.item.tipo.fecha_salida_programada
                ? moment(row.item.tipo.fecha_salida_programada).format(
                    "DD-MM-YYYY"
                  )
                : "-"
            }}
          </p>
        </template>
        <template #cell(created_at)="row">
          <div class="text-nowrap">
            {{ moment(row.item.created_at).format("DD-MM-YYYY") }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="flex flex-row items-center justify-center gap-2">
            <button
              @click="ver(row.item, row.index, $event.target)"
              class="btn-extra-primario"
            >
              <fas :icon="['fas', 'eye']" />
              Ver
            </button>
            <button
              v-permisos="'dispatch.delete'"
              @click="deleteDispatch(row.item.id)"
              class="btn-extra-secundario"
            >
              <fas :icon="['fas', 'trash']" />
              Eliminar
            </button>
          </div>
        </template>

        <template #table-busy>
          <div class="text-center my-2" style="color: #ffce1e !important">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Cargando...</strong>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        style="width: 100px; margin: auto"
        :total-rows="totalRows"
        :per-page="perPage"
        align="fill"
        size="sm"
        class="my-0"
      ></b-pagination>
    </card>
    <b-modal
      v-model="changeState"
      id="modal-estado"
      centered
      title-class="text-center w-100 px-0"
      header-class="justify-content-center"
      @hidden="cerrarModal()"
    >
      <template #modal-title> 
        <h5 class="mb-0 font-bold text-[#043161]">Cambiar estado del despacho</h5>
      </template>

      <div class="text-center py-4 px-2" v-if="itemEditando">
        <p class="text-gray-500 mb-2 text-sm">Estado actual:</p>
        <div class="mb-6 flex justify-center w-full">
           <span :class="getEstadoClass(itemEditando.estado_despacho)">
              {{ itemEditando.estado_despacho }}
           </span>
        </div>
        
        <div class="text-left w-full px-4">
            <label class="text-[#043161] font-bold text-sm mb-1 block pl-1">Seleccione nuevo estado:</label>
            <b-form-select 
              v-model="formDispatch.estado_despacho" 
              class="mb-3 w-full border border-gray-300 rounded-md"
              :options="opcionesRetiro()"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  -- Seleccione un estado --
                </b-form-select-option>
              </template>
            </b-form-select>
        </div>
      </div>

      <template #modal-footer>
        <div class="flex flex-row justify-end w-full gap-3 px-4">
          <button
            type="button"
            class="btn-danger px-4 py-2 rounded h-[35px]"
            @click="cerrarModal()"
          >
            Cancelar
          </button>
          
          <button
            type="button"
            class="btn-principal px-4 py-2 rounded h-[35px]"
            :disabled="!formDispatch.estado_despacho || formDispatch.estado_despacho === itemEditando?.estado_despacho"
            @click="confirmarChangeState()"
          >
            Guardar Cambios
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
